import React, { useState } from 'react';
import BookingForm from '../components/BookingForm';
import './Quote.css';

const Quote = () => {
  const [quote, setQuote] = useState(0);

  // Set SEO title
  React.useEffect(() => {
    document.title = "Get Free Quote - Any Time Movers AU | Adelaide Removalist Pricing";
  }, []);

  return (
    <div className="quote-page">
      <section className="quote-hero">
        <h1>Get Your Free Quote - Any Time Movers AU</h1>
        <p>Fast, transparent pricing for City of Playford, City of Salisbury, City of Tea Tree Gully, City of Port Adelaide Enfield & all Adelaide suburbs</p>
      </section>

      <section className="quote-content">
        <div className="quote-form-wrapper">
          <BookingForm quote={quote} />
        </div>

        <div className="quote-benefits">
          <h3>Why Get a Quote?</h3>
          <div className="benefit-list">
            <div className="benefit-item">
              <div className="benefit-icon">💰</div>
              <div>
                <h4>Transparent Pricing</h4>
                <p>No hidden fees or surprises. Know your cost upfront.</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">⚡</div>
              <div>
                <h4>Instant Response</h4>
                <p>We respond within 24 hours with your personalized quote.</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <div>
                <h4>No Obligation</h4>
                <p>Free quote with no commitment required.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Quote;
